import React from 'react';
import styled from 'styled-components';
import solutionsData from '../sharedData/SolutionsData';
import { pmWhite } from '../sharedData/Constants';
import Card from './Card';

import { MobileWidth } from '../sharedData/Constants';
import DownloadStudy from './DownloadStudy';
import InvertedArrow from '../assets/images/arrow_separator_inverted.png';


const CardContainer = () => {
    return(
        <StyledView>
            <StyledInvertedArrow src={InvertedArrow}/>
            <StyledContainer>
                <Title>
                Para esse ano, algumas tendências importantes no CRM estão crescendo, ajudando<br></br> as empresas a maximizar suas vendas e engajamento com os clientes. 
                </Title>
                <Subtitle>
                    Confira a seguir as principais tendências:
                </Subtitle>
                {solutionsData.map((solution, index) => (
                    <Card key={index} data={solution} />
                ))}
                <DownloadStudy/>
            </StyledContainer>
        </StyledView>
    );
};

const StyledInvertedArrow = styled.img`
    position: absolute;
    top: 16px;
    width: 150px;
    left: calc(50% - 75px);
    z-index: 1;
    @media screen and (max-width: ${MobileWidth}){
        top: 10px;
        width: 110px;
        left: calc(50% - 55px);
    }
`;

const Title = styled.div`
    font-size: 20px;
    color: ${pmWhite};
    margin-top: 147px;
    text-align: center;
    font-family: Work Sans;
    @media screen and (max-width: ${MobileWidth}){
        font-size: 11px;
        width: 269px;
        text-align: center;
        margin-top: 120px;
        br{
            display: none;
        }
    }
`

const Subtitle = styled.div`
    font-family: Work Sans;
    font-size: 20px;
    font-weight: 200;
    color: ${pmWhite};
    margin-top: 35px;
    margin-bottom: 88px;
    @media screen and (max-width: ${MobileWidth}){
        font-size: 11px;
        margin-bottom: 25px;
    }
`
const StyledContainer = styled.div` 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(270deg, rgba(84, 6, 54, 1) 4%, rgba(22, 4, 28, 1) 70%) 0% 0%;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    clip-path: polygon(65% 3%, 35% 3%, 100% 0, 100% 70%, 100% 100%, 0 100%, 0% 70%, 0 0);
`;

const StyledView = styled.div` 
    background-color: ${pmWhite};
    width: 100%;
    background-repeat:  no-repeat;
    background-size: cover;
    position: relative;
`;

export default CardContainer;